<!-- AI Automation: two integration-level switches + Manage Providers overlay -->
<div class="ai-automation">
  <h2>AI Automation</h2>

  <div fxLayout="row" class="integrationItem" fxLayoutAlign="space-between center" *ngIf="aiCopyIntegration">
    <span>Headline and Body Copy</span>
    <mat-slide-toggle [checked]="aiCopyIntegration.Status"
                      (change)="updateStatus($event, aiCopyIntegration)"></mat-slide-toggle>
  </div>

  <div fxLayout="row" class="integrationItem" fxLayoutAlign="space-between center" *ngIf="aiMontageIntegration">
    <span>Montage</span>
    <mat-slide-toggle [checked]="aiMontageIntegration.Status"
                      (change)="updateStatus($event, aiMontageIntegration)"></mat-slide-toggle>
  </div>

  <div fxLayout="row" class="integrationItem manage-row" fxLayoutAlign="space-between center">
    <span>Providers</span>
    <button mat-stroked-button color="primary" type="button" (click)="openManageProviders()">
      <mat-icon>tune</mat-icon> Manage Providers
    </button>
  </div>
</div>

<!-- Remaining integrations -->
<ng-container *ngFor="let integration of otherIntegrations">
  <div fxLayout="row" fxLayoutAlign="space-between start">
    <h2>{{integration.IntegrationName}}</h2>
    <mat-slide-toggle [checked]="integration.Status"
                      (change)="updateStatus($event, integration)"></mat-slide-toggle>
  </div>
  <div fxLayout="row" class="integrationItem" fxLayoutAlign="space-between start">
    <div *ngIf="integration.Status" fxLayout="row"><mat-icon class="activeItem">fiber_manual_record</mat-icon>
      Active</div>
    <div *ngIf="!integration.Status" fxLayout="row"><mat-icon class="inactiveItem">fiber_manual_record</mat-icon> In
      Active</div>
  </div>
</ng-container>
